"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const wrapCallbackProcessesWithFunctionLogger = ({ parentFunctionId, callbackName, callbackProcesses, functionLogger, }) => callbackProcesses.map((callbackProcess) => (Object.assign(Object.assign({}, callbackProcess), { call: async (subCallArgs) => {
        var _a;
        const parentArgs = (_a = subCallArgs.lastFunctionsOutputs) === null || _a === void 0 ? void 0 : _a.get(parentFunctionId);
        await functionLogger.updateCallback(callbackName, parentArgs);
        return callbackProcess.call(subCallArgs);
    } })));
exports.default = wrapCallbackProcessesWithFunctionLogger;
